/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from "react";

import {
  withStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  CircularProgress,
  TextField,
  Typography,
} from "@material-ui/core";

import Actions from "../../../fluid/Actions/ActionFactory";

const styles = (theme) => ({});

class CreateEvent extends Component {
  state = {
    name: null,
    name_err: false,
    name_helper_text: "",
    title: null,
    description: null,
    event_group_name: null,
    event_err: false,
    event_call: false,
  };

  componentDidMount() {
    if (this.props.event_state !== "create") {
      this.setState({
        ...this.state,
        name: this.props.event_obj.name,
        title: this.props.event_obj.title,
        description: this.props.event_obj.description,
        event_group_name: this.props.event_group,
      });
    } else {
      this.setState({
        ...this.state,
        event_group_name: this.props.event_group,
      });
    }
  }

  updateEvent = () => {
    this.setState(
      {
        ...this.state,
        event_err: false,
        name_err: false,
        name_helper_text: "",
        event_call: true,
      },
      () => {
        if (this.props.event_state === "create") {
          Actions("http_request", {
            url: "/sainapse/event",
            method: "post",
            data: {
              name: this.state.name,
              title: this.state.title,
              description: this.state.description,
              event_group_name: this.state.event_group_name,
            },
          })
            .then((res) => {
              console.log("event res", res);
              this.setState(
                {
                  ...this.state,
                  name: res.data.result.name,
                  event_call: false,
                  event_err: false,
                },
                () => this.props.close()
              );
            })
            .catch((err) => {
              let response = err.response.data;

              let nameErr = false;
              let nameErrText = "";

              if (Array.isArray(response.errors)) {
                let nameError = response.errors.find(
                  (error) => error.attribute == "name"
                );
                if (nameError) {
                  nameErr = true;
                  nameErrText = nameError.message;
                }
              }

              this.setState({
                ...this.state,
                event_err: true,
                name_err: nameErr,
                name_helper_text: nameErrText,
                event_call: false,
              });
            });
        } else {
          Actions("http_request", {
            url: "/sainapse/event/" + this.state.name,
            method: "put",
            data: {
              title: this.state.title,
              description: this.state.description,
            },
          })
            .then((res) => {
              this.setState(
                {
                  ...this.state,
                  event_call: false,
                  event_err: false,
                },
                () => this.props.close()
              );
            })
            .catch((err) => {
              let response = err.response.data;

              let nameErr = false;
              let nameErrText = "";

              if (Array.isArray(response.errors)) {
                let nameError = response.errors.find(
                  (error) => error.attribute == "name"
                );
                if (nameError) {
                  nameErr = true;
                  nameErrText = nameError.message;
                }
              }
              this.setState({
                ...this.state,
                event_err: true,
                name_err: nameErr,
                name_helper_text: nameErrText,
                event_call: false,
              });
            });
        }
      }
    );
  };

  handleChange = (field, value) => {
    this.setState({
      ...this.state,
      [field]: value,
    });
  };

  renderErrorMessage = () => {
    if (this.state.event_err) {
      return (
        <Typography variant="caption" color="secondary">
          {this.props.event_state === "create"
            ? "Error occured while creating the event"
            : "Error occured while updating the event"}
        </Typography>
      );
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <Dialog style={{ zIndex: this.props.zIndex }} open={this.props.open}>
        <DialogTitle>
          {this.props.event_state === "create"
            ? "Create Event"
            : "Modify Event"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Events are entities that can be triggered by other entities in
            Sainapse. Every event should be grouped under an Event Group. Events
            should have unique names.
          </DialogContentText>
          <Typography>
            Event Group : <em>{this.state.event_group_name}</em>
          </Typography>
          <TextField
            autoFocus
            disabled={this.props.event_state === "create" ? false : true}
            margin="dense"
            id="name"
            label="Event Name"
            fullWidth
            error={this.state.name_err}
            helperText={this.state.name_helper_text}
            value={this.state.name}
            onChange={(event) => this.handleChange("name", event.target.value)}
          />
          <TextField
            margin="dense"
            id="name"
            label="Title"
            fullWidth
            value={this.state.title}
            onChange={(event) => this.handleChange("title", event.target.value)}
          />
          <TextField
            margin="dense"
            id="name"
            label="Description"
            multiline
            rowsMax={4}
            fullWidth
            value={this.state.description}
            onChange={(event) =>
              this.handleChange("description", event.target.value)
            }
          />
          {this.renderErrorMessage()}
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            startIcon={
              this.state.event_call ? (
                <CircularProgress color="primary" size={20} />
              ) : null
            }
            onClick={this.updateEvent}
          >
            Create
          </Button>
          <Button color="secondary" onClick={this.props.close}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withStyles(styles)(CreateEvent);
